import React from 'react';
import PropTypes from 'prop-types';

const UilWhatsapp = (props) => {
  const { color, size, ...otherProps } = props
  return React.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: color,
    ...otherProps
  }, React.createElement('path', {
    d: 'M14.512,11.98163c-.247-.124-1.465-.724-1.692-.806-.227-.083-.392-.124-.557.124-.165.247-.64.806-.785.971-.144.165-.289.185-.536.061a6.76439,6.76439,0,0,1-1.991-1.228,7.45685,7.45685,0,0,1-1.378-1.716c-.144-.248-.015-.382.109-.505.111-.111.248-.289.371-.434a1.698,1.698,0,0,0,.248-.413.45522.45522,0,0,0-.021-.434c-.062-.124-.557-1.343-.763-1.839-.201-.482-.405-.417-.558-.425-.144-.007-.309-.009-.474-.009a.91.91,0,0,0-.66.311,2.77669,2.77669,0,0,0-.867,2.065,4.81408,4.81408,0,0,0,1.011,2.562,11.03456,11.03456,0,0,0,4.23,3.739,14.57754,14.57754,0,0,0,1.412.522,3.38962,3.38962,0,0,0,1.56.097,2.54342,2.54342,0,0,0,1.671-1.176,2.06125,2.06125,0,0,0,.144-1.178c-.061-.104-.226-.165-.474-.289m2.492-9.079a9.91267,9.91267,0,0,0-15.598,11.958L0,19.99562l5.254-1.377a9.90506,9.90506,0,0,0,4.736,1.206h.004a9.91505,9.91505,0,0,0,7.01-16.922m-2.633,13.989a8.24541,8.24541,0,0,1-4.377,1.259H9.99a8.22321,8.22321,0,0,1-4.192-1.149l-.301-.178-3.118.818.832-3.04-.195-.312a8.23688,8.23688,0,1,1,11.355,2.602'
  }));
};

UilWhatsapp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

UilWhatsapp.defaultProps = {
  color: 'currentColor',
  size: '24',
};

export default UilWhatsapp;